<template>
    <v-form
        ref='form'
        v-if='!loading'
        v-model='valid'
        lazy-validation
        @submit.prevent='CompleteUserAccountInformation'
    >
        <v-container>
            <v-row>
                <v-col cols='12'>
                    <InfoAlert v-if='apartment_id'>
                        <div slot='default'>
                            اطلاعات حساب جهت فعالیت مالی مجموعه می‌باشد در زمانی که مدیر درخواست برداشت از صندوق مجموعه
                            ثبت کند به این حساب انتقال پیدا میکند و همینطور به ساکنین مجموعه جهت پرداخت کارت به کارت در
                            صورتی که تمایل به پرداخت کارتی داشتند نمایش داده می‌شود
                        </div>
                    </InfoAlert>
                </v-col>
                <v-col cols='12'>
                    <h3 class='d-block font-weight-bold flex-grow-1 mb-4 mt-3'>تکمیل اطلاعات مالی</h3>
                </v-col>
                <v-col cols='12'>
                    <v-text-field
                        v-model='model.account.name'
                        label=' به نام'
                    >
                    </v-text-field>
                </v-col>
                <v-col cols='12'>
                    <v-text-field
                        v-model='model.account.accountNumber'
                        :rules='rules.account.accountNumber'
                        type='number'
                        min='0'
                    >
                        <template #label>
                            شماره حساب
                        </template>
                    </v-text-field>
                </v-col>
                <v-col cols='12'>
                    <v-text-field
                        v-model='model.account.shebaNumber'
                        :rules='rules.account.shebaNumber'
                        suffix='IR'
                        min='0'
                        hint='نیاز به وارد کردن "IR" نیست'
                    >
                        <template #label>
                            شماره شبا
                        </template>
                    </v-text-field>
                </v-col>
                <v-col cols='12'>
                    <v-text-field
                        :value='cardNumber'
                        :rules='rules.account.cardNumber'
                        v-mask="'####-####-####-####'"
                        @input='updateValue("cardNumber",$event)'
                        placeholder='####-####-####-####'
                        type='text'
                    >
                        <template #label>
                            شماره کارت
                        </template>
                    </v-text-field>
                </v-col>
                <v-col cols='12'>
                    <v-btn

                        name='submit'

                        :disabled='!valid ||loading'
                        color='primary'
                        type='submit'
                        :loading='loading'
                        @click='validate'
                    >ثبت
                    </v-btn>
                    <v-btn
                        outlined
                        class='mr-2'
                        @click='goBack'
                    >
                        انصراف
                    </v-btn>
                </v-col>
            </v-row>
        </v-container>
    </v-form>
</template>

<script>
    import axios from 'axios';
    import InfoAlert from '@/components/Alerts/InfoAlert';
    import { isShebaValid, verifyCardNumber, digitsFaToEn } from '@persian-tools/persian-tools';
    import { mapActions } from 'vuex';

    export default {
        name: 'From',
        components: { InfoAlert },
        data: () => ({
            valid: true,
            apartment_id: '',
            loading: true,
            cardNumber: '',
            model: {
                account: {
                    shebaNumber: '',
                    accountNumber: '',
                    cardNumber: ''
                }
            },
            rules: {
                account: {
                    accountNumber: [
                        // v => !!v || 'شماره حساب اجباری میباشد',
                        // v => v ? v.length > 9 || 'شماره حساب معتبر نیست' : false,
                        v => v.length === 0 ? true : v.length > 9 || 'شماره حساب معتبر نیست'
                    ],
                    shebaNumber: [
                        // v => !!v || 'شماره شبا اجباری میباشد',
                        // v => v ? v.match(/^(?=.{24}$)[0-9]*$/) || 'شماره شبا معتبر نیست' : false
                        v => v.length === 0 ? true : isShebaValid('IR' + v) || 'شماره شبا معتبر نیست'

                    ],
                    cardNumber: [
                        // v => !!v || 'شماره کارت اجباری میباشد',
                        // v => v ? v.replace(/-/g, '').match(/^(?=.{16}$)[0-9]*$/) || 'شماره کارت معتبر نیست' : false
                        v => v.length === 0 ? true : verifyCardNumber(v.replace(/-/g, '')) || 'شماره کارت معتبر نیست'
                    ]
                }
            }
        }),
        methods: {
            goBack() {
                this.$store.commit('goBack');
                this.$router.replace(this.$store.state.history.page);
            },
            handleInputCardNumber(v) {
                this.cardNumber = v;
                this.model.account.cardNumber = v.replace(/-/g, '');
            },
            updateValue(name, $event) {
                let value = digitsFaToEn($event);
                this.model.account[name] = value;
                this.cardNumber = value;
                // this.$emit('input', this.model.account[name] = value);
            },
            validate() {
                this.$refs.form.validate();
            },
            async fetchUserAccount() {
                this.loading = true;
                await axios
                    .get('/api/users/account')
                    .then(res => {
                        if (res.data.account) {
                            this.model.account = res.data.account;
                            this.cardNumber = res.data.account.cardNumber;
                            this.shebaNumber = res.data.account.shebaNumber;
                            this.accountNumber = res.data.account.accountNumber;
                        }
                    })
                    .catch(err => {
                        console.error(err);
                        this.$snackbar.showMessage({
                            content: 'خطا در سرور',
                            color: 'warning'
                        });
                    });
                this.loading = false;
            },
            async fetchApartmentAccount() {
                this.loading = true;
                await axios
                    .get(`/api/apartments/${this.apartment_id}/account`)
                    .then(res => {

                        if (res.data.account) {
                            this.model.account = res.data.account;
                            this.cardNumber = res.data.account.cardNumber;
                        }
                    })
                    .catch(err => {
                        console.error(err);
                        this.$snackbar.showMessage({
                            content: 'خطا در سرور',
                            color: 'warning'
                        });
                    });
                this.loading = false;
            },
            async CompleteUserAccountInformation() {
                let Url = '/api/account';
                if (this.apartment_id) {
                    Url = `/api/apartments/${this.apartment_id}/account`;
                }
                this.loading = true;
                await axios
                    .put(Url, this.model.account)
                    .then(() => {
                        let message = 'اطلاعات شما بروزرسانی شد.';
                        this.$snackbar.showMessage({
                            content: message,
                            color: 'success'
                        });
                        if (!this.apartment_id) {
                            this.$router.push({ name: 'Profile' });
                        } else {
                            this.$router.push({ name: 'Settings' });
                        }

                    })
                    .catch(err => {
                        this.$snackbar.showMessage({
                            content: 'خطا در سرور',
                            color: 'warning'
                        });
                        console.error(err);
                    });
                this.loading = false;
            },
            ...mapActions(['showBreadCrumbs', 'setBreadCrumbsTemp'])
        },
        async created() {
            this.apartment_id = this.$route.params.apartment_id;
            if (this.apartment_id) {
                await this.fetchApartmentAccount();
            } else {
                await this.fetchUserAccount();
            }

            let href = window.location.pathname + window.location.search;
            await this.setBreadCrumbsTemp({
                key: 'editAccount',
                value: {
                    text: `اطلاعات مالی`,
                    href: href
                }
            });
            this.loading = false;
        },
        async updated() {
            if (this.apartment_id) {
                await this.showBreadCrumbs(['home', 'apartmentDetail', 'ApartmentSettings', 'editAccount']);
            } else {
                await this.showBreadCrumbs(['profile', 'editAccount']);
            }
        }
    };
</script>
